/**
 * Module dependencies.
 */

import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

/**
 * Export `Props` type.
 */

export type Props = {
  className?: string;
  message?: string;
  style?: CSSProperties;
};

/**
 * `EmptyMessage` styled component.
 */

const EmptyMessage = styled.div`
  padding: 8px 16px;
  width: 100%;
`;

/**
 * Export `EmptyResultsOption` component.
 */

export function EmptyResultsOption({ message, ...rest }: Props) {
  const { t } = useTranslation();

  return <EmptyMessage {...rest}>{message ?? t('common:form.errors.noSearchResults')}</EmptyMessage>;
}
